import { openModalV2 } from "~/shared_states/modal";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";
import { HowToUseModal } from "~/components/webstore_telescope/how_to_use_modal";
import { TncsModal } from "~/components/webstore_telescope/tncs_modal";
import { useTelescopeContext } from "@hubble/telescope";

export function CtaSection() {
  const { brand } = useBrandl2WebstoreTelescopeContext();
  const { routeData } = useBrandl2WebstoreTelescopeContext();
  const { components } = useTelescopeContext();
  const openHowToUse = () => {
    openModalV2(
      () => <HowToUseModal brandId={routeData()!.brand.externalId} />,
      {
        expandToFullHeight: true,
      }
    );
  };

  const openThingsToNote = () => {
    openModalV2(() => <TncsModal productId={brand().externalId} />, {
      expandToFullHeight: true,
    });
  };
  return (
    <div class="flex w-full flex-row gap-2">
      <components.Button
        text="How to use / reedeem"
        variant="secondary"
        style="neutral"
        size={40}
        expanded={true}
        onClick={openHowToUse}
      ></components.Button>
      <components.Button
        text="Things to note"
        variant="secondary"
        style="neutral"
        size={40}
        expanded={true}
        onClick={openThingsToNote}
      ></components.Button>
    </div>
  );
}
